/**
 * Common JS functions
 */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import cAppeared from '../components/c-appeared';
import navBurger from '../blocks/nav-burger';
import navProp from '../blocks/navp';
import outline from '../components/c-outline';
import header from '../blocks/header';
import preloader from '../components/c-preloader';
import cookieConsentDelay from '../components/c-cookie-consent-delay';
import cSkipMain from '../components/c-skip-main';
import { breakpoints } from '../config/breakpoints';

cookieConsentDelay();
cAppeared();
header();
navBurger();
navProp($);
outline();
preloader();
cSkipMain();

// initImagesLazyLoad();

// function initImagesLazyLoad() {
//     observer = lozad(); // lazy loads elements with default selector as '.lozad'
//     observer.observe();
// }

/**
 * Pendry Form Remove Auto-Label
 * @param targetId
 */
function pendryFormRemoveAutoLabel(targetId) {
  $(`#${targetId}`).closest('.wpcf7-form-control-wrap').find(`#label_${targetId}`).remove();
}

/**
 * Pendry Form Remove All Auto-Labels
 * @param formId
 */
function pendryFormRemoveAllAutoLabels(formId) {
  $(`#${formId}`).find('.form__label-auto').remove();
}

/**
 * Pendry Form Remove auto aria-label
 * @param targetId
 */
function pendryFormRemoveAutoAriaLabel(targetId) {
  $(`#${targetId}`).removeAttr('aria-label');
}

/**
 * Pendry Form Auto-Label
 * @param targetId
 * @param targetValue
 */
function pendryFormAutoLabel(targetId, targetValue) {
  let placeholder;

  if ($(`#${targetId}`).attr('placeholder')) {
    placeholder = $(`#${targetId}`).attr('placeholder');
  } else if ($(`#${targetId}`).closest('div').data('placeholder')) {
    placeholder = $(`#${targetId}`).closest('div').data('placeholder');
  } else {
    placeholder = $(`#${targetId}`).attr('name');
  }

  const label = `<span for="${targetId}" id="label_${targetId}" class="form__label-auto">${placeholder}</span>`;

  if (targetValue !== '' && $(`#label_${targetId}`).length === 0) {
    $(`#${targetId}`).closest('.wpcf7-form-control-wrap').prepend(label);
    pendryFormRemoveAutoAriaLabel(targetId);
  }
  if (targetValue === '' || targetValue.toLowerCase() === $(`#${targetId}`).attr('name').toLowerCase()) {
    pendryFormRemoveAutoLabel(targetId);
  }
}

window.pendryFormAutoLabel = pendryFormAutoLabel;

/**
 * CF7 form submit listener
 */
document.addEventListener('wpcf7mailsent', (event) => {
  const id = event.target.id || event.target.closest('.wpcf7').getAttribute('id');
  pendryFormRemoveAllAutoLabels(id);
}, false);

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    const wpcf7Forms = document.querySelectorAll('form.wpcf7-form');

    wpcf7Forms.forEach((form) => {
      form.reset();
      const wrap = form.closest('.wpcf7');
      if (wrap) {
        pendryFormRemoveAllAutoLabels(wrap.getAttribute('id'));
      }
    });
  }
});

// jQuery functions
(function () {
  function smoothScroll(hash) {
    const duration = 700;
    let headerHeight = 0;

    if (window.screen.width >= breakpoints.lg) {
      headerHeight = $('.header-container .navp-container').height();
    } else {
      headerHeight = $('.header-container .header').height();
    }

    const blockScrollMargin = parseInt($(hash).css('scroll-margin-top'), 10);
    let scrollTopValue = 0;

    if (blockScrollMargin) {
      scrollTopValue = $(hash).offset().top - blockScrollMargin;
    } else {
      scrollTopValue = $(hash).offset().top - headerHeight;
    }

    if ($(hash).hasClass('item-offer')) {
      const elOfferDetails = $(`${hash} + .item-offer-details`);
      const offerDetailsBottom = elOfferDetails.offset().top + elOfferDetails.outerHeight();
      const viewPortBottom = scrollTopValue + document.documentElement.clientHeight;
      const heightDiff = viewPortBottom - offerDetailsBottom;

      if (heightDiff < 0) {
        scrollTopValue = offerDetailsBottom - document.documentElement.clientHeight;
      }
    }

    $('html,body').animate({ scrollTop: scrollTopValue }, duration);

    setTimeout(() => {
      $(document).trigger('scrollToHash', [hash]);
    }, duration);
  }

  function getLocation(href) {
    const l = document.createElement('a');
    l.href = href;
    return l;
  }

  function catchHash() {
    const { hash } = window.location;
    const bookingPath = '/(#/)';
    // Exit if booking page
    if (window.location.href.match(bookingPath)) {
      return false;
    }
    if (!$(hash).length) {
      return false;
    }
    if (hash) {
      smoothScroll(hash);
    }

    return false;
  }

  $(document).on('click', '.navigation__sub-navigation-link[href*=\\#]', function (event) {
    const requestedLinkPath = getLocation($(this).attr('href')).pathname;
    const pathName = window.location.pathname;
    const { hash } = this;

    if (requestedLinkPath.replace(/^\/|\/$/g, '') === pathName.replace(/^\/|\/$/g, '')) {
      event.preventDefault();
      window.history.pushState('', document.title, window.location.pathname + hash);
      smoothScroll(hash);
    }
  });
  // @todo what is it?
  // $(document).scroll(() => {
  //   const { hash } = window.location;
  //   /* eslint-disable-next-line */
  //   const hashu = hash.replace(/^\#|\/$/g, '');
  //   const element = document.getElementById(hashu);
  //   if (element) {
  //     const topPos = element.getBoundingClientRect();
  //   }
  // });

  $(window).bind('hashchange load', () => {
    catchHash();
  });

  $(window).ready(() => {
    catchHash();
  });

  // Add form auto-label
  $(document).on('input change', '.form__input', (event) => {
    pendryFormAutoLabel(event.target.id, event.target.value);
  });

  /**
     * All drop downs
     * @type {*|HTMLElement}
     */
  const $dropDown = $('.form__input--select');

  $dropDown.change(function () {
    if ($(this).val() === '') {
      $(this).addClass('form__input--empty');
    } else {
      $(this).removeClass('form__input--empty');
    }
  });
  $dropDown.change();
}());
